export const mapSeatToOrderSeat = (seat, areas) => {
    const area = areas.find(a => a.number === seat.position.areaNumber);
    if (!area)
        throw new Error('Cannot map Seat to OrderSeat without an area');
    return {
        seatId: seat.id,
        areaCategoryId: seat.areaCategoryId,
        position: seat.position,
        seatLabel: seat.label,
        rowLabel: seat.rowLabel,
        areaName: area.name
    };
};
